import React from 'react';
import useScrollToTop from '../components/useScrollToTop';
import Button from '../components/Button';
import './floorpages.css';
import simpleHomePlan1 from '../img/elevation_img_11.avif'; // Replace with relevant image
import affordableHousePatna from '../img/elevation_img_13.avif'; // Replace with relevant image
import efficientLayoutBihar from '../img/elevation_img_1.avif'; // Replace with relevant image

const PageSimpleHomeNaksha = () => {
  useScrollToTop();

  return (
    <>
    <div className='project-container'>
    <div className="project-details">
      <h1 className="">Simple & Affordable House Plans in Patna: Practical Designs for Easy Living</h1>

      <section className="">
        <h2 className="">Efficient and Budget-Friendly Home Designs for Patna</h2>
        <p className="">
          Looking for straightforward and budget-friendly house plans in Patna? Our collection of simple home nakshas focuses on efficient layouts, minimal complexity, and comfortable living without unnecessary frills. Ideal for first-time homeowners, small families, or those seeking cost-effective construction in Bihar.
        </p>
      </section>

      <section className="">
        <h2 className="">Key Features of Our Simple Home Nakshas for Patna</h2>
        <ul className="list-items">
          <li>
            <strong>Efficient Layouts:</strong> Maximizing usable space with well-organized room arrangements suitable for Patna's context.
            <img src={efficientLayoutBihar} alt="Efficient Simple Home Layout in Bihar" className="project-image" />
          </li>
          <li>
            <strong>Cost-Effective Designs:</strong> Focusing on practical and affordable construction methods and material choices relevant to Bihar.
            <img src={affordableHousePatna} alt="Affordable House Design in Patna" className="project-image" />
          </li>
          <li>
            <strong>Easy Maintenance:</strong> Simple designs that are easier to build, clean, and maintain in the long run.
          </li>
          <li>
            <strong>Optimal for Smaller Plots:</strong> Efficient utilization of space, making them ideal for compact plots in Patna.
          </li>
          <li>
            <strong>Focus on Essential Living Spaces:</strong> Prioritizing comfortable bedrooms, functional kitchens, and practical living areas.
          </li>
        </ul>
      </section>

      <section className="">
        <h2 className="">Explore Our Gallery of Simple Home Plans for Patna</h2>
        <ul className="list-items">
          <li>A range of 1 BHK and 2 BHK house plans designed for simplicity and affordability in Patna.</li>
          <li>Clear and easy-to-understand floor plans with basic dimensions.</li>
          <li>Options for single-story and potentially compact multi-story designs.</li>
          <li>Designs that prioritize functionality and comfortable living.</li>
          <li>Adaptable layouts that can be slightly modified to suit individual needs.</li>
          <li>Consideration for natural light and basic ventilation for the climate of Bihar.</li>
        </ul>
      </section>

      <section className="">
        <h2 className="">Detailed AutoCAD 2D Drawings for Your Simple Home in Patna</h2>
        <p className="">
          Our detailed AutoCAD 2D drawings provide clear and precise blueprints for constructing your simple and affordable home in Patna, ensuring a straightforward building process.
          <img src={simpleHomePlan1} alt="Simple Home Plan for Patna" className="project-image" />
        </p>
        <ul className="list-items">
          <li>Clear and dimensioned floor plans for easy understanding by builders.</li>
          <li>Basic layouts for electrical and plumbing points.</li>
          <li>Simple elevation views showcasing the basic structure.</li>
          <li>Foundation and roof plans suitable for standard construction methods in Bihar.</li>
        </ul>
      </section>
       <div className="">
          <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
            <Button className="button-outlined">वास्तु शास्त्र के अनुसार घर का डिज़ाइन बनवाने के लिए हमसे संपर्क करें!</Button>
          </a>
        </div>
    </div>
    </div>
    </>
  );
};

export default PageSimpleHomeNaksha;